import { Machine } from 'xstate';

export default Machine({
  id: 'lead-ad-capture-fields',
  initial: 'limitedOptions',
  states: {
    limitedOptions: {
      on: {
        TOGGLE_SHOW_ALL: 'allOptions',
      },
    },
    allOptions: {
      on: {
        TOGGLE_SHOW_ALL: 'limitedOptions',
      },
    },
  },
});
